import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "generate-endpoint-connector" }
const _hoisted_2 = { class: "generate-form" }
const _hoisted_3 = {
  key: 0,
  class: "connectors-warning"
}
const _hoisted_4 = { class: "connector-table" }

import { FormRules } from "element-plus/es/components/form/src/types";
import { reactive, ref } from "vue";
import { generateEndpointsApi } from "../../api/endpoint/endpointApi";
import { ElMessage } from "element-plus";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


export default /*@__PURE__*/_defineComponent({
  __name: 'GenerateEndpointConnectorView',
  setup(__props) {

const generateForm = reactive({
  number: null,
  namePrefix: "",
  typePrefix: "",
  oneTimeCode: "",
});
const generateRule = reactive<FormRules>({
  number: [
    { required: true, message: "数量不得为空", trigger: "blur" },
    { min: 1, max: 100, message: "数量范围1-100", trigger: "blur" },
  ],
});

const btnSubmitGenerateLoading = ref<boolean>(false);
const connectors = ref<any>([]);
const submitGenerate = async () => {
  if (generateForm.number === null) return;
  btnSubmitGenerateLoading.value = true;
  const response = await generateEndpointsApi(
    generateForm.number,
    generateForm.namePrefix,
    generateForm.typePrefix,
    generateForm.oneTimeCode
  );
  btnSubmitGenerateLoading.value = false;
  console.log(response);
  if (response) {
    generateForm.oneTimeCode = "";
    generateForm.number = null;
    connectors.value = response;
    ElMessage.success("生成成功");
  } else {
    ElMessage.error("生成失败");
  }
};

const exportExcel = () => {
  if (connectors.value <= 0) return;
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("终端三元组");
  worksheet.columns = [
    { header: "终端名称", key: "name", width: 30 },
    { header: "Client ID", key: "id", width: 20 },
    { header: "username", key: "username", width: 25 },
    { header: "password", key: "password_hash", width: 30 },
  ];
  connectors.value.forEach((connector: any) => {
    worksheet.addRow(connector);
  });
  const today = new Date();
  const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `终端三元组-${formattedDate}.xlsx`); // 文件名带上当前日期
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h1", null, "终端连接生成器", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        model: generateForm,
        "label-width": "auto",
        inline: true,
        rules: generateRule
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "创建数量",
            prop: "number"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: generateForm.number,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((generateForm.number) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "终端名称前缀",
            prop: "number"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: generateForm.namePrefix,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((generateForm.namePrefix) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "终端类型前缀",
            prop: "number"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: generateForm.typePrefix,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((generateForm.typePrefix) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "一次性生成码",
            prop: "oneTimeCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: generateForm.oneTimeCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((generateForm.oneTimeCode) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "success",
                loading: btnSubmitGenerateLoading.value,
                onClick: submitGenerate
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" 生成 ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    (connectors.value.length > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _cache[6] || (_cache[6] = _createTextVNode(" 注意：以下三元组仅显示一次，刷新或退出页面后将无法再次查看连接密码，请注意保存！ ", -1)),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: exportExcel
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("导出", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (connectors.value.length > 0)
        ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: connectors.value,
            height: "100%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "终端名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "id",
                label: "Client ID"
              }),
              _createVNode(_component_el_table_column, {
                prop: "username",
                label: "username"
              }),
              _createVNode(_component_el_table_column, {
                prop: "password_hash",
                label: "password"
              })
            ]),
            _: 1
          }, 8, ["data"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})